// 各课程主题色：新增课程时只需在此登记一次，组件按 courseId 查表取色
export const COURSE_THEME_COLOR: Record<string, string> = {
  sme: '#FFB339',
  'student-training': '#C4B0FF',
  civil: '#77C2FF',
  'general-staff': '#F36928',
  cybersecurity2026: '#EE6E2F',
  education: '#EE6E2F',
  finance: '#55C2FF',
};

// 默认主题色：未登记主题色的课程兜底使用，保证左侧菜单配色始终统一
export const DEFAULT_COURSE_THEME_COLOR = '#EE6E2F';

export const getCourseThemeColor = (courseId: string) =>
  COURSE_THEME_COLOR[courseId] || DEFAULT_COURSE_THEME_COLOR;
